import { Button, Illustration } from "@saviynt/design-system";
import { useEffect, useState } from "react";
import { FormattedMessage, MessageDescriptor, useIntl } from "react-intl";

interface SuccessStepProps {
  onContinue: () => void;
  buttonLabel?: MessageDescriptor & { values?: Record<string, unknown> };
}

export default function SuccessStep({
  onContinue,
  buttonLabel,
}: SuccessStepProps) {
  const intl = useIntl();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onContinue();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onContinue]);

  const defaultLabel = (
    <FormattedMessage
      id="JPiPnp"
      defaultMessage="Go to Saviynt ({countdown}s)"
      description="Button text to navigate to Saviynt with countdown"
      values={{ countdown }}
    />
  );

  return (
    <div className="flex flex-col items-center space-y-6">
      <Illustration kind="Confirmation" className="w-40 h-40" />
      <Button onClick={onContinue}>
        {buttonLabel
          ? intl.formatMessage(buttonLabel, {
              ...buttonLabel.values,
              countdown,
            })
          : defaultLabel}
      </Button>
    </div>
  );
}
